import { Stack, Typography } from "@mui/material";

export const CustomDetailsListHeader = ({
  title,
  headerRightContent = null,
  headerStyle = {},
}) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      height="83px"
      p="32px 24px"
      sx={headerStyle}
    >
      <Typography
        variant="subtitle1"
        fontWeight={600}
        lineHeight="19px"
        minWidth="160px"
      >
        {title}
      </Typography>
      {headerRightContent}
    </Stack>
  );
};
